import React from 'react';
import { ArrowRight as ArrowRightIcon } from '@phosphor-icons/react';
import { Section, SectionTitle, Lead } from '../Section';
import { clinicians } from '../../data/proposal';
const ingredients = ['Portrait / clinical image', 'Name + credentials', 'One intriguing clinical question', 'CTA into the full case'];
export function HookSection() {
  return <Section id="hook" index="06" label="The hook" fill data-id="element-106" data-mp="35ii6jq4x4457">
      <div className="grid gap-5 lg:grid-cols-[1fr_0.85fr] lg:items-end lg:gap-14" data-id="element-107" data-mp="27yf3wsmyd0qh">
        <SectionTitle data-id="element-108" data-mp="2cx8kitxjd7uv">
          Put the clinician
          <br data-id="element-109" data-mp="2ctuglh984qlb" />
          front and centre.
        </SectionTitle>
        <Lead data-id="element-110" data-mp="2htp7vlwwvi6w">
          The clinician brings credibility and personality. The clinical dilemma brings relevance
          and curiosity. Filtek becomes part of a clinical story rather than another product
          message.
        </Lead>
      </div>

      <ul className="mt-5 flex flex-wrap gap-2" data-id="element-111" data-mp="1u5fqqxan7im3">
        {ingredients.map(item => <li key={item} className="rounded-full border border-white/15 px-3.5 py-1.5 font-body text-sm text-white/70" data-id="element-112" data-mp="12y1gp53wch5g">
            {item}
          </li>)}
      </ul>

      <div className="mt-5 grid min-h-0 flex-1 gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-113" data-mp="t7zukiv3t8t6">
        {clinicians.map(clinician => <article key={clinician.id} className="group flex min-h-0 flex-col overflow-hidden rounded-xl border border-white/10 bg-white/[0.03] transition-colors hover:border-primary/50" data-id="element-114" data-mp="p5lbpyrfq91w">
            <div className="min-h-[120px] flex-1 overflow-hidden bg-[#02241e]" data-id="element-115" data-mp="f6vtg4vmmml4">
              <img src={clinician.portrait} alt={`Portrait of ${clinician.name}`} className="h-full w-full object-cover object-[50%_20%]" data-id="element-116" data-mp="aa5bfc09hgx2" />
            </div>
            <div className="p-4" data-id="element-117" data-mp="24mlqn2b1c5e2">
              <h3 className="font-heading text-lg leading-tight text-white" data-id="element-118" data-mp="20ltea06v9kdk">{clinician.name}</h3>
              <p className="mt-0.5 font-body text-[11px] uppercase tracking-[0.14em] text-secondary/70" data-id="element-119" data-mp="3u4int6k6nfpm">
                {clinician.credentials} · {clinician.location}
              </p>
              <p className="mt-2.5 font-heading text-base leading-snug text-primary" data-id="element-120" data-mp="2rpcoutu4rvf">
                “{clinician.hook}”
              </p>
              <p className="mt-3 inline-flex items-center gap-2 font-body text-[11px] font-semibold uppercase tracking-[0.14em] text-white" data-id="element-121" data-mp="3p4nvqzoo8k2z">
                {clinician.cta}
                <ArrowRightIcon size={12} weight="bold" className="text-primary transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-122" data-mp="loqgwdfkenyb" />
              </p>
            </div>
          </article>)}
      </div>
    </Section>;
}